import { DownloadPageContent } from '../../components/pages/download';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';

const Download = (): JSX.Element => {
  usePageVistTracker();

  return (
    <Layout description="" pageTitle="Desktop App" shouldIndex={false}>
      <DownloadPageContent />
    </Layout>
  );
};

export default Download;
